import React from 'react'

import { ImageTitleDetailsCardsType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

import { Card } from './Card/Card'
import { TitleSection } from './ImageTitleDetailsCards.styled'

export const ImageTitleDetailsCards = (props: ImageTitleDetailsCardsType): JSX.Element => {
    const { title, subtitle, imageTitleDetailsDescription, mode, items } = props

    return (
        <TitleSection title={title} subtitle={subtitle} description={imageTitleDetailsDescription} mode={mode}>
            <Grid container>
                {items.map((item) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={item.title}
                        mdDownSpacingBottom={6}
                        mdUpSpacingLeft={3}
                        mdUpSpacingRight={3}
                        mdUpSpacingBottom={3}
                    >
                        <Card {...item} />
                    </Grid>
                ))}
            </Grid>
        </TitleSection>
    )
}
